import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TSubject } from '@datatype/iyagigo/type';
import { TJlptCategory, TToeicCategory } from '@datatype/iyagigo/type';

// interface ICategory {}

interface IState {
  question: string;
  answer: string;
  // jlpt
  jlpt1Category: TJlptCategory;
  jlpt2And3Category: TJlptCategory;
  jlpt4And5Category: TJlptCategory;
  jlpt1Categories: TJlptCategory[];
  jlpt2And3Categories: TJlptCategory[];
  jlpt4And5Categories: TJlptCategory[];

  // toeic
  toeic950Category: TToeicCategory;
  toeic750And850Category: TToeicCategory;
  toeic550And650Category: TToeicCategory;
  toeic950Categories: TToeicCategory[];
  toeic750And850Categories: TToeicCategory[];
  toeic550And650Categories: TToeicCategory[];

  // topik
  topik1Category: string;
  topik2Category: string;
  topik1Categories: string[];
  topik2Categories: string[];
}

const initialState: IState = {
  question: '',
  answer: '',
  // jlpt
  jlpt1Category: 'vocabulary',
  jlpt2And3Category: 'vocabulary',
  jlpt4And5Category: 'vocabulary',
  jlpt1Categories: ['vocabulary', 'grammar', 'reading', 'listening'], // ['문자·어휘', '문법', '독해', '청해']
  jlpt2And3Categories: ['vocabulary', 'grammar', 'reading', 'listening'], // ['문자·어휘', '문법', '독해', '청해']
  jlpt4And5Categories: ['vocabulary', 'grammar', 'reading', 'listening'], // ['문자·어휘', '문법', '독해', '청해']

  // toeic
  toeic950Category: 'reading',
  toeic750And850Category: 'reading',
  toeic550And650Category: 'reading',
  toeic950Categories: ['reading', 'listening'], // ['읽기', '듣기']
  toeic750And850Categories: ['reading', 'listening'], // ['읽기', '듣기']
  toeic550And650Categories: ['reading', 'listening'], // ['읽기', '듣기']

  // topik
  topik1Category: '읽기',
  topik2Category: '읽기',
  topik1Categories: ['읽기', '듣기'],
  topik2Categories: ['읽기', '듣기', '쓰기'],
};

const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    clickCategory: (
      state,
      action: PayloadAction<{
        subject: TSubject;
        category: TJlptCategory | TToeicCategory;
      }>,
    ) => {
      const { subject, category } = action.payload;

      switch (subject) {
        case 'jlpt1':
          state.jlpt1Category = category;
          break;
        case 'jlpt2-3':
          state.jlpt2And3Category = category;
          break;
        case 'jlpt4-5':
          state.jlpt4And5Category = category;
          break;
        case 'toeic950':
          state.toeic950Category = category as TToeicCategory;
          break;
        case 'toeic750-850':
          state.toeic750And850Category = category as TToeicCategory;
          break;
        case 'toeic550-650':
          state.toeic550And650Category = category as TToeicCategory;
          break;
        case 'topik1':
          state.topik1Category = category;
          break;
        case 'topik2':
          state.topik2Category = category;
          break;
        default:
      }
    },
  },
});

export const actions = testSlice.actions;
export default testSlice.reducer;
